const googlepayUtils = require('../../utils/googlepay');

/**
 * Get GooglePay PaymentsClient
 *
 * @param {string} environment - environment
 * @param {Object} merchantInfo - object with merchant name and id
 * @returns {Object} - GooglePay PaymentsClient
 */
function getGooglePaymentsClient(environment, merchantInfo) {
    if (!environment || !merchantInfo) {
        return null;
    }
    // eslint-disable-next-line
    return new google.payments.api.PaymentsClient({
        environment,
        merchantInfo,
        paymentDataCallbacks: {
            onPaymentAuthorized,
            onPaymentDataChanged
        }
    });
}

/**
 * Callback when the GooglePay script is Loaded.
 */
function onGooglePayLoaded() {
    const urlButtonRenderData = $('#googlepay-wrapper').data('url-button-render-data');

    if (!urlButtonRenderData) {
        return;
    }

    $.ajax({
        url: urlButtonRenderData,
        type: 'POST',
        dataType: 'json',
        /**
         * Asynchronous request success state
         *
         * @param {Object} data - data object
         */
        success: data => {
            const {environment, merchantInfo, isReadyToPayRequest, buttonOptions} = data;
            const paymentsClient = getGooglePaymentsClient(environment, merchantInfo);

            if (!paymentsClient || !isReadyToPayRequest || !buttonOptions.allowedPaymentMethods) {
                console.error('There is no data needed to create GooglePay button.');
                return;
            }

            paymentsClient
                .isReadyToPay(isReadyToPayRequest)
                .then(function (response) {
                    if (response.result) {
                        createGooglePayButton(paymentsClient, buttonOptions);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        },
        /**
         * Asynchronous request error state
         *
         * @param {Object} err - error object
         */
        error: err => {
            console.error(err);
        }
    });
}

/**
 * Creates GooglePay button
 *
 * @param {Object} paymentsClient - GooglePay PaymentsClient
 * @param {Object} buttonOptions - object to define the button's options - e.g. display and locale settings
 */
function createGooglePayButton(paymentsClient, buttonOptions) {
    /**
     * Callback when the GooglePay Button is Clicked
     */
    function onGooglePayButton() {
        onGooglePayButtonClicked(paymentsClient);
    }

    const googlePayButton = buttonOptions;

    googlePayButton.onClick = onGooglePayButton;

    const button = paymentsClient.createButton(googlePayButton);
    const container = document.getElementById('googlepay-wrapper');

    if (container) {
        const gpayWrapper = $('#googlepay-wrapper');
        const urlPaymentDataRequest = gpayWrapper.data('url-payment-data-request');
        const isStorePickup = $('.js-bopis-pick-up').length > 0 && $('.js-bopis-pick-up').hasClass('selected');
        if (isStorePickup) {
            button.addClass('google-pay-hidden');
        }

        container.appendChild(button);
        $('.gpay-card-info-container').css('z-index', 1);

        $.ajax({
            url: urlPaymentDataRequest,
            type: 'POST',
            dataType: 'json',
            /**
             * Asynchronous request success state
             *
             * @param {Object} dataRequest - data request
             */
            success: dataRequest => {
                const paymentDataRequest = googlepayUtils.getGooglePaymentDataRequest(dataRequest);

                if (!paymentDataRequest) {
                    console.error('There is no payment data needed to call GooglePay Sheet.');
                    return;
                }

                const paymentDataRequestJSON = JSON.stringify(paymentDataRequest);
                gpayWrapper.data('payment-data-request', paymentDataRequestJSON);
            },
            /**
             * Asynchronous request error state
             *
             * @param {Object} err - error object
             */
            error: err => {
                console.error(err);
            }
        });
    }
}

/**
 * Callback when the GooglePay Button is Clicked
 *
 * @param {Object} paymentsClient - GooglePay PaymentsClient
 */
function onGooglePayButtonClicked(paymentsClient) {
    const gpayWrapper = $('#googlepay-wrapper');
    const paymentDataRequest = JSON.parse(gpayWrapper.data('payment-data-request'));

    paymentsClient
        .loadPaymentData(paymentDataRequest)
        .then(function (paymentData) {
            googlepayUtils.handleGooglePayResponse(paymentData);
        })
        .catch(function (err) {
            console.error(err);
        });
}

/**
 * Callback when payment data changed on GooglePay sheet
 *
 * @param {Object} intermediatePaymentData - intermediate payment data
 * @returns {Promise} returns a promise to be handled by GooglePay
 */
function onPaymentDataChanged(intermediatePaymentData) {
    return new Promise(function (resolve) {
        const urlHandlePaymentInfo = $('#googlepay-wrapper').data('url-handle-payment-info');
        const paymentDataRequestUpdate = {};

        $.ajax({
            url: urlHandlePaymentInfo,
            type: 'POST',
            dataType: 'json',
            data: {
                paymentData: JSON.stringify(intermediatePaymentData)
            },
            /**
             * Asynchronous request success state
             *
             * @param {Object} data - data object
             */
            success: data => {
                if (!data.errorMsg) {
                    const shippingOptions = googlepayUtils.getShippingOptions(data.shippingMethods);
                    const {shippingOptionData} = intermediatePaymentData;

                    if (
                        intermediatePaymentData.callbackTrigger === 'INITIALIZE' ||
                        intermediatePaymentData.callbackTrigger === 'SHIPPING_ADDRESS'
                    ) {
                        const selectedShippingOptionId = shippingOptions.defaultSelectedOptionId;
                        paymentDataRequestUpdate.newShippingOptionParameters = shippingOptions;
                        paymentDataRequestUpdate.newTransactionInfo = googlepayUtils.calculateNewTransactionInfo(
                            data.transactionInfo,
                            data.shippingMethods,
                            selectedShippingOptionId
                        );
                    } else if (intermediatePaymentData.callbackTrigger === 'SHIPPING_OPTION') {
                        paymentDataRequestUpdate.newTransactionInfo = googlepayUtils.calculateNewTransactionInfo(
                            data.transactionInfo,
                            data.shippingMethods,
                            shippingOptionData.id
                        );
                    }
                } else {
                    paymentDataRequestUpdate.error = {
                        reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                        message: data.errorMsg,
                        intent: intermediatePaymentData.callbackTrigger
                    };
                }

                googlepayUtils.restoreBasket();
                resolve(paymentDataRequestUpdate);
            },
            /**
             * Asynchronous request error state
             *
             * @param {Object} err - error object
             */
            error: err => {
                console.error(err);
                const errorMsg = $('#googlepay-wrapper').data('msg-error-selected-address');
                paymentDataRequestUpdate.error = {
                    reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                    message: errorMsg,
                    intent: intermediatePaymentData.callbackTrigger
                };

                googlepayUtils.restoreBasket();
                resolve(paymentDataRequestUpdate);
            }
        });
    });
}

/**
 * Callback when payment authorized is done on GooglePay sheet
 *
 * @param {Object} paymentData - payment data
 * @returns {Promise} returns a promise to be handled by GooglePay
 */
function onPaymentAuthorized(paymentData) {
    return new Promise(function (resolve) {
        const urlHandlePaymentInfo = $('#googlepay-wrapper').data('url-handle-payment-info');

        $.ajax({
            url: urlHandlePaymentInfo,
            type: 'POST',
            dataType: 'json',
            data: {
                paymentData: JSON.stringify(paymentData)
            },
            /**
             * Asynchronous request success state
             *
             * @param {Object} data  - data object
             */
            success: data => {
                if (!data.errorMsg) {
                    resolve({
                        transactionState: 'SUCCESS'
                    });
                } else {
                    resolve({
                        transactionState: 'ERROR',
                        error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                            message: data.errorMsg,
                            reason: 'PAYMENT_DATA_INVALID'
                        }
                    });
                }
            },
            /**
             * Asynchronous request error state
             *
             * @param {Object} err  - error object
             */
            error: err => {
                console.error(err);
                const errorMsg = $('#googlepay-wrapper').data('msg-error-payment-invalid');
                resolve({
                    transactionState: 'ERROR',
                    error: {
                        intent: 'PAYMENT_AUTHORIZATION',
                        message: errorMsg,
                        reason: 'PAYMENT_DATA_INVALID'
                    }
                });
            }
        });
    });
}

module.exports = {
    /**
     * Inits the GooglePay script
     */
    init() {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://pay.google.com/gp/p/js/pay.js');
        script.onload = onGooglePayLoaded;
        document.head.appendChild(script);
    }
};
